import React, { ReactNode } from 'react';
import { BoxProps, Typography } from '@mui/material';
import { EmptyStateRoot } from './EmptyState.styles';

export type EmptyStateProps = Omit<BoxProps, 'title'> & {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
};

export const EmptyState = ({ icon, title, description, action, ...boxProps }: EmptyStateProps) => (
  <EmptyStateRoot {...boxProps}>
    {icon}
    <Typography variant="h6" mb={2}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" mb={3}>
        {description}
      </Typography>
    )}
    {action}
  </EmptyStateRoot>
);
